import React, { useEffect, useState, useRef, useMemo } from "react";
import {
  DataGrid,
  GridSortDirection,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarDensitySelector,
  GridToolbarExport,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import { Link } from "react-router-dom";
import { getMasjidColumns } from "./MasjidColumns";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { FcPlus } from "react-icons/fc";
import "./MasjidTablle.scss";
import TextField from "@mui/material/TextField";
import { useDebounce } from "use-debounce";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { useStateContext } from "../../../contexts/StateContextProvider";
import { ChangeSnackbar } from "../../../Redux/Actions/SnackbarActions/SnackbarActions";
import { useNavigate } from "react-router-dom";
import { MasjidDataType } from "../../../Redux/Actions/MasjidActions/AddingMasjids";
import { handleSnackbar } from "../../../helpers/SnackbarHelper/SnackbarHelper";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import "react-lazy-load-image-component/src/effects/blur.css";
import { useAppSelector, useAppThunkDispatch } from "../../../Redux/hooks";
import { AdminInterFace } from "../../../Components/FeedComponents/Feed/Feed";
import SocialInput from "../../../Pages/Shared/SocialInput/SocialInput";
import {
  mailChecker,
  phoneChecker,
  redirectToVanillaPortal,
} from "../../../helpers/HelperFunction";
import toast from "react-hot-toast";
import EmailChip from "../../../Pages/Shared/EmailChip/EmailChip";
import { Masjid, ReceivedEmailObject } from "../../../../Types";
import { useMutation, useQuery } from "@apollo/client";
import {
  GET_MASJIDS,
  GET_MASJIDS_COUNT,
  GET_SORTED_MASJIDS,
} from "../../../graphql/queries";
import { CREATE_MASJID } from "../../../graphql/mutations";
import { Box, CircularProgress, IconButton, Tooltip, Typography, Badge } from "@mui/material";
import StatusActionModal from "../../Shared/StatusActionModal/StatusActionModal";
import MasjidDetails from "./MasjidDetails/MasjidDetails";
import MasjidStatusHandler from "./MasjidStatusHandler";
import { getStatus } from "./Helper";
import {
  useSearchMasjids,
  useSearchMasjidsForMasjidTable,
} from "../../../graphql/Masjids/query";
import FilterBuilder from "../../Shared/FilterBuilder/FilterBuilder";
import FilterListIcon from "@mui/icons-material/FilterList";

type MasjidToolbarProps = {
  onOpenAdvancedFilter: () => void;
  hasActiveFilter: boolean;
};

const MasjidToolbar: React.FC<MasjidToolbarProps> = ({
  onOpenAdvancedFilter,
  hasActiveFilter,
}) => (
  <GridToolbarContainer>
    {/* Default toolbar actions */}
    <GridToolbarColumnsButton />
    <GridToolbarDensitySelector />
    <GridToolbarExport />

    {/* Spacer */}
    <Box sx={{ flexGrow: 1 }} />

    {/* Quick filter */}
    <GridToolbarQuickFilter debounceMs={500} />

    {/* Advanced Filter button */}
    <Tooltip title="Advanced Filter">
      <IconButton
        onClick={onOpenAdvancedFilter}
        color={hasActiveFilter ? "primary" : "default"}
        data-testid="FilterListIcon"
        size="small"
        sx={{ ml: 1 }}
      >
        <FilterListIcon />
        <Typography
          variant="body2"
          sx={{
            ml: 0.5,
            display: { xs: "none", sm: "inline-flex" },
          }}
        >
          Advanced Filter
        </Typography>
      </IconButton>
    </Tooltip>
  </GridToolbarContainer>
);

const MasjidTable = () => {
  const [text, setText] = useState("");
  const { setSearchTerm } = useStateContext()!;
  const { results } = useStateContext()!;
  const [debouncedValue] = useDebounce(text, 1600);
  const { getResults, searchTerm } = useStateContext()!;
  const [selectedValue, setSelectedValue] = useState<any>(null);
  let MasjidNameRef = useRef<HTMLInputElement | null>(null);
  let masjidNameInputErrorRef = useRef<HTMLInputElement | null>(null);
  const CountryRef = useRef<string | null>(null);
  let MasjidDescRef = useRef<HTMLInputElement | null>(null);
  let MasjidAddressRef = useRef<HTMLInputElement | null>(null);
  let MasjidLatitudeRef = useRef<HTMLInputElement | null>(null);
  let MasjidLongitudeRef = useRef<HTMLInputElement | null>(null);
  let MasjidContactRef = useRef<any>(null);
  let MasjidFacebookLinkRef = useRef<HTMLInputElement | null>(null);
  let MasjidWebsiteLinkRef = useRef<HTMLInputElement | null>(null);
  let whatsAppNumRef = useRef<HTMLInputElement | null>(null);
  let emailRef = useRef<HTMLInputElement | null>(null);
  const [MasjidNames, setMasjidNames] = useState([]);
  const dispatch = useAppThunkDispatch();
  const [AddModalOpen, setAddModalOpen] = useState(false);
  const [country, setCountry] = React.useState("");
  const [MasjidAddressError, setMasjidAddressError] = useState(false);
  const [addressErrorMgs, setAddressErrorMgs] = useState("Manditory field");
  const [MasjidNameError, setMasjidNameError] = useState(false);
  const [MasjidBracketError, setMasjidBracketError] = useState(false);
  const [MasjidDescError, setMasjidDescError] = useState(false);
  const [MasjidLatitudeError, setMasjidLatitudeError] = useState(false);
  const [MasjidLongitudeError, setMasjidLongitudeError] = useState(false);
  const [MasjidFacebookError, setMasjidFacebookError] = useState(false);
  const [MasjidWebsiteLinkError, setMasjidWebsiteLinkError] = useState(false);
  const [whatsAppError, setWhatsAppError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [receivedEmails, setReceivedEmails] = useState<ReceivedEmailObject[]>(
    []
  );
  const [MasjidPhoneError, setMasjidPhoneError] = useState(false);
  const [MasjidDuplicationDropDown, setMasjidDuplicationDropDown] =
    useState(false);
  const [DropDownOpen, setDropDownOpen] = useState(false);
  const [LatPaste, setLatPaste] = useState(0);
  const [LonPaste, setLonPaste] = useState(0);

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedMasjidId, setSelectedMasjidId] = useState("");
  const [selectedMasjid, setSelectedMasjid] = useState<Masjid | null>(null);

  let navigate = useNavigate();
  const adminString = localStorage.getItem("admin");
  const admin: AdminInterFace | null = adminString
    ? JSON.parse(adminString)
    : null;
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [rowCount, setRowCount] = useState(0);

  const { data: countData } = useQuery(GET_MASJIDS_COUNT, {
    fetchPolicy: "network-only",
  });
  // const masjids = useAppSelector((state) => state.masjids);
  const [masjids, setMasjids] = useState([]);
  const [query, setQuery] = useState("");
  const [filterBuilderOpen, setFilterBuilderOpen] = useState(false);
  const [advancedFilter, setAdvancedFilter] = useState<string | null>(null);
  const [sortModel, setSortModel] = useState<
    { field: string; sort: GridSortDirection }[]
  >([{ field: "updatedAt", sort: "desc" }]);

  const { loading, error, data, refetch } = useQuery(GET_SORTED_MASJIDS, {
    variables: {
      limit: advancedFilter ? 10000 : pageSize, // Fetch all results for client-side pagination when filtered
      page: advancedFilter ? 1 : page, // Always fetch page 1 for filtered results
      sort:
        sortModel.length > 0
          ? JSON.stringify({
              [sortModel[0].field]: sortModel[0].sort === "desc" ? -1 : 1,
            })
          : null,

      filter: advancedFilter,
    },
    skip: !!(query && !advancedFilter), // Skip only when there's a search query AND no advanced filter
    fetchPolicy: "network-only",
  });

  const {
    masjids: searchData,
    loading: searchLoading,
    error: searchError,
    refetch: refetchSearch,
  } = useSearchMasjidsForMasjidTable(query, 1, 20);
  // 2. Fetch the total record count from a separate GraphQL query (assuming GET_MASJIDS_COUNT exists)

  useEffect(() => {
    if (countData && countData.totalMasjids) {
      setRowCount(Number(countData.totalMasjids) ?? 0);
    }
  }, [countData]);
  const displayRows = useMemo(() => {
    // Priority: advanced filter > search query > main data
    if (advancedFilter) {
      return masjids; // Use main query data when advanced filters are applied
    } else if (query) {
      return searchData && searchData.length ? searchData : [];
    } else {
      return masjids; // Use main query data when no filters
    }
  }, [advancedFilter, query, searchData, masjids]);

  useEffect(() => {
    if (query && sortModel) {
      refetchSearch();
    }
  }, [query, sortModel]);

  useEffect(() => {
    if (data && data.getMasjids) {
      setMasjids(data?.getMasjids ?? []);
    } else if (error) {
      toast.error("Error fetching masjids");
    }
  }, [data, error]);

  useEffect(() => {
    if (!modalOpen) setSelectedMasjid(null);
  }, [modalOpen]);
  const [
    createMasjid,
    { data: createData, loading: createLoading, error: creatError },
  ] = useMutation(CREATE_MASJID);

  const handleCreateMasjid = async (masjidData: any) => {
    try {
      const response = await createMasjid({
        variables: {
          input: masjidData,
        },
      });
      toast.success("Masjid created successfully");
      if (response?.data?.createMasjid?._id) {
        setTimeout(() => {
          redirectToVanillaPortal(response.data.createMasjid._id, "MASJID");
        }, 1000);
        setAddModalOpen(false);
        setSelectedValue(null);
      }
    } catch (err) {
      toast.error(`Error creating masjid: ${err}`);
      console.error("Error creating masjid:", err);
    }
  };
  useEffect(() => {
    if (admin?.role === "superadmin" || admin?.role === "admin") {
    }
  }, []);

  useEffect(() => {
    if (text.length > 28) {
      DropDownOpen && setDropDownOpen(false);
    }
    if (debouncedValue) setSearchTerm(debouncedValue);
  }, [debouncedValue]);

  useEffect(() => {
    if (searchTerm === "") {
      setSelectedValue(null);
    }
    if (searchTerm !== "") {
      if (searchTerm.length < 28) {
        getResults(searchTerm);

        if (
          Array.isArray(results) &&
          results.length > 0 &&
          !results.some((result) => result.error)
        ) {
          setDropDownOpen(true);
        } else {
          setDropDownOpen(false);
        }
      }
    }
  }, [searchTerm]);

  const handleActionClick = (action: string, details: Masjid) => {
    console.log(action);
    console.log(details);
    setModalOpen(true);
    setSelectedMasjidId(details._id);
    setSelectedMasjid(details);
  };
  const handleModalUpdateClose = () => {
    setAddModalOpen(false);
    setMasjidBracketError(false);
    setMasjidAddressError(false);
    setMasjidNameError(false);
    setMasjidDescError(false);
    setMasjidLatitudeError(false);
    setMasjidLongitudeError(false);
    setMasjidPhoneError(false);
    setMasjidFacebookError(false);
    setMasjidWebsiteLinkError(false);
    setCountry("");
    setText("");
  };

  const handleNewMasjid = () => {
    let coordinates = [
      parseFloat(MasjidLatitudeRef.current?.value ?? "0"),
      parseFloat(MasjidLongitudeRef.current?.value ?? "0"),
    ];

    if (text.length <= 0) {
      setMasjidAddressError(true);
    } else if (MasjidAddressRef.current?.value) {
      setMasjidAddressError(false);
    }

    if (!MasjidNameRef.current?.value) {
      setMasjidNameError(true);
    } else if (MasjidNameRef.current?.value) {
      setMasjidNameError(false);
    }

    if (!MasjidDescRef.current?.value) {
      setMasjidDescError(true);
    } else if (MasjidDescRef.current?.value) {
      setMasjidDescError(false);
    }

    if (!MasjidLatitudeRef.current?.value) {
      setMasjidLatitudeError(true);
    } else if (MasjidLatitudeRef.current?.value) {
      setMasjidLatitudeError(false);
    }

    if (!MasjidLongitudeRef.current?.value) {
      setMasjidLongitudeError(true);
    } else if (MasjidLongitudeRef.current?.value) {
      setMasjidLongitudeError(false);
    }

    if (MasjidContactRef.current?.value && !country) {
      toast.error("Place Country Code Before the Number.");
      return;
    }
    if (!country) {
      toast.error("Ensure that you have selected a country before proceeding ");
      return;
    }
    // if (!MasjidContactRef.current?.value) {
    //   setMasjidPhoneError(true);
    // }

    const fbLink = MasjidFacebookLinkRef.current?.value;
    const webLink = MasjidWebsiteLinkRef.current?.value;
    const whatsAPP = whatsAppNumRef.current?.value;
    const emailVal = emailRef.current?.value;

    if (emailVal && !mailChecker(emailVal)) return;
    let externalLink = [
      { name: "Facebook", url: fbLink },
      { name: "Website", url: webLink },
      { name: "Whatsapp", url: whatsAPP },
      { name: "Email", url: emailVal },
      ...receivedEmails,
    ];
    externalLink = externalLink.filter((link) => link.url);

    let updatedData: MasjidDataType = {
      masjidName: MasjidNameRef.current?.value ?? "",
      description: MasjidDescRef.current?.value ?? "",
      address: text + " " + country,
      location: {
        type: "Point",
        coordinates: [coordinates[1], coordinates[0]],
      },
      contact: MasjidContactRef.current?.value.replace(/\s+/g, "") ?? "",
    };
    if (externalLink.length > 0) {
      updatedData = { ...updatedData, externalLinks: externalLink };
    }

    if (
      coordinates[0] &&
      coordinates[1] &&
      MasjidDescRef.current?.value &&
      MasjidNameRef.current?.value &&
      text &&
      !MasjidBracketError
      // MasjidContactRef.current?.value
    ) {
      handleCreateMasjid(updatedData);
      // handleAddMasjid(updatedData);
    } else {
      handleSnackbar(
        true,
        "warning",
        "Please enter correct details before trying again",
        dispatch
      );
    }
  };

  const handleAddMasjidModal = () => {
    setAddModalOpen(true);
  };

  function validate(field: any, regex: any) {
    if (regex.test(field.value)) {
      field.className = "correctInput";
      if (MasjidBracketError) {
        setMasjidBracketError(false);
      }
    } else {
      if (!MasjidBracketError) {
        setMasjidBracketError(true);
      }
      field.className = "errorInput";
    }
  }

  const checkBrackets = (field: any) => {
    const stack = [];
    const bracketLookup: { [key: string]: string } = {
      "{": "}",
      "(": ")",
      "[": "]",
    };
    for (const key of field.value) {
      if (Object.keys(bracketLookup).includes(key)) {
        // matches open brackets
        stack.push(key);
      } else if (Object.values(bracketLookup).includes(key)) {
        //matches closed brackets
        const lastBracket = stack.pop();
        if (bracketLookup[lastBracket] !== key) {
          return false;
        }
      }
    }
    if (stack.length > 0) {
      if (!MasjidBracketError) {
        setMasjidBracketError(true);
      }
      field.className = "errorInput";
    } else if (MasjidBracketError) {
      setMasjidBracketError(false);
    }
    return stack.length === 0;
  };

  const checkDuplications = (name: any) => {
    if (name.value?.length >= 5 && name.value?.length <= 35) {
      let masjidNames: any = [];
      let Names = masjids.filter((item: Masjid) => {
        let masjidName = item.masjidName.toLowerCase().trim();
        return masjidName.includes(name.value.toLowerCase().trim());
      });

      if (Names.length > 0) {
        !MasjidDuplicationDropDown && setMasjidDuplicationDropDown(true);
        Names.map((item: Masjid) => masjidNames.push(item.masjidName));
        setMasjidNames(masjidNames);
      } else {
        setMasjidNames([]);
        setMasjidDuplicationDropDown(false);
      }
    } else {
      if (name.value.length < 4) {
        MasjidDuplicationDropDown && setMasjidDuplicationDropDown(false);
      }
    }
  };

  const patterns: Record<string, RegExp> = {
    masjidName: /^[a-zA-Z &,()-]+$/,
  };

  const handleInputCheckChange = (e: any) => {
    validate(e.target, patterns[e.target.attributes.name.value]);
    checkBrackets(e.target);
    checkDuplications(e.target);
  };

  const handleCountryChange = (country: string) => {
    CountryRef.current = country;
    setCountry(country);
  };

  const handleDropDown = () => {
    setDropDownOpen(false);
  };

  const onChoose = (searchTerm: any) => {
    setText(searchTerm.display_address);
    setSelectedValue(searchTerm);
    setDropDownOpen(false);
  };

  const handleTextChange = (event: any) => {
    const inputTex = event.target.value;
    setText(inputTex);
    const specialCharacterRegex = /[^,a-zA-Z0-9-()#\s]/;
    if (specialCharacterRegex.test(inputTex)) {
      setMasjidAddressError(true);
      setAddressErrorMgs("Address contains special characters");
    } else {
      setMasjidAddressError(false);
      setAddressErrorMgs("mandatory  field");
    }
    if (event.target?.value.length <= 0) {
      setDropDownOpen(false);
    }
  };

  const handleLatPaste = (e: any) => {
    let pasted = e.clipboardData.getData("Text");
    let string1 = `${pasted}`;
    if (string1.includes(",")) {
      let locOfDivide = string1.indexOf(",");
      let lat = string1.substr(0, locOfDivide);
      let lon = string1.substr(locOfDivide + 2);
      setLatPaste(parseFloat(lat));
      MasjidLatitudeRef.current!.value = lat;
      setLonPaste(parseFloat(lon));
      MasjidLongitudeRef.current!.value = lon;
    } else {
      setLatPaste(parseFloat(string1));
      MasjidLatitudeRef.current!.value = string1;
    }
  };

  const handleLongPaste = (e: any) => {
    let pasted = e.clipboardData.getData("Text");
    let string1 = `${pasted}`;
    if (string1.includes(",")) {
      let locOfDivide = string1.indexOf(",");
      let lat = string1.substr(0, locOfDivide);
      let lon = string1.substr(locOfDivide + 2);
      setLatPaste(parseFloat(lat));
      MasjidLatitudeRef.current!.value = "" + parseFloat(lat);
      setLonPaste(parseFloat(lon));
      MasjidLongitudeRef.current!.value = "" + parseFloat(lon);
    } else {
      setLonPaste(parseFloat(string1));
      MasjidLongitudeRef.current!.value = "" + parseFloat(string1);
    }
  };

  function handleEmptyPaste(e: any) {
    if (text.length < 1) {
      const snackbarFailureDetails = {
        snackbarOpen: true,
        snackbarType: "warning",
        snackbarMessage:
          "Please Add the Address to paste the longitude and latitude",
      };
      dispatch(ChangeSnackbar(snackbarFailureDetails));
    }
  }
  const handlePhoneChange = (num: string) => {
    // if (!country) toast.error("you Have to Select Number First");
  };

  return (
    <div className="StaleMasjidTableContainer">
      <Dialog open={AddModalOpen}>
        <DialogTitle>Add New Masjid</DialogTitle>
        <DialogContent>
          <input
            id="outlined-required"
            // fullWidth
            // margin="dense"
            name="masjidName"
            className="defaultNameInput"
            placeholder="Enter the masjid Name"
            // sx={{ marginBottom: "20px", height: "30px", width: "80%" }}
            type="text"
            min={6}
            autoComplete="Off"
            required
            pattern="/^[a-zA-Z ,()-]+$/"
            onChange={handleInputCheckChange}
            ref={MasjidNameRef}
            defaultValue={
              MasjidNameRef.current?.value && MasjidNameRef.current?.value
            }
          />
          {MasjidBracketError || MasjidNameError ? (
            <p className="helperTextInput" ref={masjidNameInputErrorRef}>
              Masjid Name must have letters and circular brackets only and
              contain at least 6 characters{" "}
            </p>
          ) : (
            <div className="BottomForName"> </div>
          )}
          {MasjidDuplicationDropDown && (
            <div className="MasjidNamesDropdown">
              <div className="MasjidNamesDropdownContent">
                {MasjidDuplicationDropDown &&
                  MasjidNames.slice(0, 5).map((item) => (
                    <Link
                      to={"/masjid/" + item}
                      className="MasjidNamesDropdownElement"
                    >
                      {item}
                    </Link>
                  ))}
              </div>
            </div>
          )}
          <br />
          <div style={{ display: "flex", flexDirection: "row" }}>
            <TextField
              key="address"
              value={text}
              error={MasjidAddressError}
              helperText={MasjidAddressError ? addressErrorMgs : ""}
              autoComplete="Off"
              type="text"
              placeholder="🔎 Enter Masjid Address or Name"
              onChange={(e) => {
                handleTextChange(e);
              }}
              inputProps={{ style: { fontSize: 13 } }}
              fullWidth
            />

            {DropDownOpen && (
              <AiOutlineCloseCircle
                className="CloseIcon"
                onClick={handleDropDown}
              />
            )}
          </div>
          {!DropDownOpen && <div style={{ marginBottom: "1.2rem" }}></div>}
          {DropDownOpen &&
            results.length > 0 &&
            !results.some((result) => result.error) && (
              <div className="MasjidNamesDropdown">
                <div className="MasjidNamesDropdownContent">
                  {results.length > 0 &&
                    !results.some((result) => result.error) &&
                    results.slice(0, 15).map((item) => (
                      <div
                        onClick={() => onChoose(item)}
                        className="dropdownElement"
                      >
                        {item.display_name}
                      </div>
                    ))}
                </div>
              </div>
            )}
          {text.length > 10 && !selectedValue ? (
            <TextField
              required
              id="outlined-required"
              autoComplete="off"
              error={MasjidLatitudeError}
              helperText={MasjidLatitudeError ? "Manditory field" : ""}
              sx={{ marginBottom: 3, marginTop: 2 }}
              placeholder="Latitude"
              defaultValue={LatPaste && LatPaste}
              onPaste={(e: any) => {
                e.target.blur();
                handleLatPaste(e);
              }}
              inputRef={MasjidLatitudeRef}
              type="number"
            />
          ) : (
            <TextField
              type="number"
              required
              error={MasjidLatitudeError}
              helperText={MasjidLatitudeError ? "Manditory field" : ""}
              id="outlined-required"
              autoComplete="off"
              inputRef={MasjidLatitudeRef}
              onChange={(e) => {
                if (text.length < 10) {
                  setSelectedValue(null);
                }
              }}
              sx={{ marginBottom: 3, marginTop: 2 }}
              onPaste={(e) => {
                e.preventDefault();
                handleEmptyPaste(e);
                return false;
              }}
              placeholder="Latitude"
              value={selectedValue && selectedValue.lat}
            />
          )}
          {text.length > 18 && !selectedValue ? (
            <TextField
              required
              id="outlined-required"
              autoComplete="Off"
              error={MasjidLongitudeError}
              helperText={MasjidLongitudeError ? "Manditory field" : ""}
              sx={{ marginBottom: 3, marginLeft: 5, marginTop: 2 }}
              placeholder="Longitude"
              defaultValue={LonPaste && LonPaste}
              onPaste={(e: any) => {
                e.target.blur();
                handleLongPaste(e);
              }}
              inputRef={MasjidLongitudeRef}
              type="number"
            />
          ) : (
            <TextField
              required
              type="number"
              autoComplete="Off"
              error={MasjidLongitudeError}
              helperText={MasjidLongitudeError ? "Manditory field" : ""}
              sx={{ marginBottom: 3, marginLeft: 7, marginTop: 2 }}
              placeholder="Longitude"
              id="outlined-required"
              inputRef={MasjidLongitudeRef}
              onPaste={(e) => {
                e.preventDefault();
                handleEmptyPaste(e);
                return false;
              }}
              value={selectedValue && selectedValue?.lon}
            />
          )}

          <div className="phoneInputContainer">
            <PhoneInput
              error={MasjidPhoneError}
              placeholder="Enter phone number"
              onCountryChange={(e: any) => handleCountryChange(e)}
              ref={MasjidContactRef}
              style={{ width: "30rem", height: "100%", outline: "none" }}
              onChange={handlePhoneChange}
            />
          </div>
          {MasjidPhoneError && (
            <p style={{ color: "red" }}>Please Enter the Contact Number</p>
          )}

          <TextField
            id="outlined-required"
            variant="outlined"
            error={MasjidDescError}
            helperText={MasjidDescError ? "Manditory field" : ""}
            fullWidth
            multiline
            rows={4}
            inputRef={MasjidDescRef}
            type="text"
            autoComplete="Off"
            sx={{ marginTop: 3, height: "50%" }}
            placeholder="Enter the Description of the masjid"
          />
          <SocialInput
            isError={MasjidFacebookError}
            inputRf={MasjidFacebookLinkRef}
            placeholderTx={"Facebook Link"}
            height={"20%"}
          />
          <SocialInput
            isError={MasjidWebsiteLinkError}
            inputRf={MasjidWebsiteLinkRef}
            placeholderTx={"Website Link"}
          />
          <SocialInput
            isError={whatsAppError}
            inputRf={whatsAppNumRef}
            placeholderTx={"What's App  Group Name"}
          />
          <SocialInput
            isError={emailError}
            inputRf={emailRef}
            placeholderTx={"Official Email Address"}
          />
          <EmailChip emails={receivedEmails} setEmails={setReceivedEmails} />
        </DialogContent>
        <DialogActions style={{ justifyContent: "space-around" }}>
          <Button onClick={handleModalUpdateClose} style={{ color: "grey" }}>
            Cancel
          </Button>
          <Button
            data-testid="add-button"
            onClick={handleNewMasjid}
            disabled={createLoading} // Disable the button while loading
            startIcon={createLoading ? <CircularProgress size={20} /> : null} // Add a spinner
          >
            {createLoading ? "Loading..." : "Add"}
          </Button>
        </DialogActions>
      </Dialog>
      <div className="AddMasjidContainer">
        {(admin?.role === "superadmin" || admin?.role === "admin") && (
          <Button
            className="link"
            onClick={handleAddMasjidModal}
            variant="outlined"
            style={{ marginBottom: "10px", marginTop: "15px", color: "Green" }}
          >
            Add New Masjid <FcPlus className="PlusIcon" />
          </Button>
        )}
      </div>

      <div
        className="masjid-page-table"
        style={{
          ...(loading || !displayRows?.length ? { height: "650px" } : {}),
        }}
      >
        <DataGrid
          sx={{
            "& .MuiDataGrid-cell": {
              fontSize: "0.8rem",
              userSelect: "text",
            },
            "&.MuiDataGrid-root": {
              overflowX: "auto",
              width: "100%",
            },
            "& .MuiDataGrid-virtualScroller": {
              overflowX: "auto", // Allow horizontal scrolling
              overflowY: "auto", // Allow vertical scrolling
            },
            "& .MuiDataGrid-virtualScroller::-webkit-scrollbar": {
              width: "10px", // Set the width of the scrollbar
            },
            "& .MuiDataGrid-virtualScroller::-webkit-scrollbar-track": {
              background: "#f1f1f1", // Set the background of the track
            },
            "& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb": {
              background: "#888", // Set the color of the thumb (scrollbar handle)
              borderRadius: "10px", // Make the scrollbar thumb rounded
            },
            "& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb:hover": {
              background: "#555", // Change color when the thumb is hovered
            },
          }}
          loading={advancedFilter ? loading : (query ? searchLoading : loading)}
          rows={
            admin?.role === "superadmin" || admin?.role === "admin"
              ? displayRows
              : []
          }
          page={page - 1}
          columns={getMasjidColumns(handleActionClick)}
          pageSize={pageSize}
          rowCount={advancedFilter ? displayRows.length : (query ? searchData?.length : rowCount)}
          pagination
          paginationMode={advancedFilter ? "client" : "server"}
          onPageChange={(newPage) => setPage(newPage + 1)}
          onPageSizeChange={(newPageSize) => {
            setPageSize(newPageSize);
            setPage(0);
          }}
          filterMode="server"
          onFilterModelChange={(model) => {
            // If your DataGrid version provides quickFilterValues, join them into a single string.
            // Otherwise, adjust this code based on the filter model structure.
            const newQuery = model.quickFilterValues
              ? model.quickFilterValues.join(" ")
              : "";
            console.log(newQuery, model.quickFilterValues);
            // if (newQuery) {
            setPage(1);
            // }
            console.log(newQuery);
            setQuery(newQuery);
          }}
          sortingMode="server"
          sortModel={sortModel}
          onSortModelChange={(newModel) => {
            const sortedModel = newModel.map((item) => ({
              field: item.field,
              sort: item.sort ?? ("asc" as GridSortDirection),
            }));
            setSortModel(sortedModel);
            setPage(1); // Reset to first page when sorting changes.
          }}
          // sortModel={sortModel}
          // onSortModelChange={(newModel) => {
          //   setSortModel(newModel);
          //   setPage(1);
          // }}
          // onFilterModelChange={(model) => {
          //   model.quickFilterValues ? model.quickFilterValues.join(" ") : "";
          //   setPage(1);
          //   setQuery(newQuery);
          // }}
          getRowId={(row) => row._id}
          rowsPerPageOptions={[5]}
          disableSelectionOnClick
          disableColumnFilter
          components={{
            Toolbar: MasjidToolbar,
          }}
          componentsProps={{
            toolbar: {
              onOpenAdvancedFilter: () => setFilterBuilderOpen(true),
              hasActiveFilter: !!advancedFilter,
            },
          }}
          getRowClassName={(params) => {
            return getStatus(params.row?.isFreezed, params.row?.isVerified) ===
              "rejected"
              ? "frozen-masjid-row"
              : "";
          }}
        />
      </div>
      <MasjidStatusHandler
        refetch={refetch}
        open={modalOpen}
        setOpen={setModalOpen}
        onConfirm={() => {}}
        selectedMasjid={selectedMasjid as Masjid}
        setSelectedMasjid={setSelectedMasjid}
      />
      <FilterBuilder
        entityType="MASJID"
        open={filterBuilderOpen}
        onClose={() => setFilterBuilderOpen(false)}
        onApply={(filter) => {
          setAdvancedFilter(filter);
          setPage(1);
          setQuery(""); // Clear search query when applying advanced filter
        }}
        pageId="masjid-table"
      />
    </div>
  );
};
export default MasjidTable;
